import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { useNativePlatform } from "@/hooks/useNativePlatform";
import { cn } from "@/lib/utils";

type NativeSlideInPanelProps = {
  children: ReactNode;
  className?: string;
  /** Always animate on native (e.g. settings section). */
  always?: boolean;
  /**
   * fade — route transitions (no transform; keeps position:fixed sticky bars working).
   * slide — in-panel slide (settings detail).
   */
  variant?: "fade" | "slide";
};

/**
 * iOS-style entrance for native detail panels and pushed routes.
 */
export function NativeSlideInPanel({
  children,
  className,
  always = false,
  variant = "fade",
}: NativeSlideInPanelProps) {
  const { isNative } = useNativePlatform();
  const location = useLocation();
  const navState = location.state as { nativeSlideIn?: boolean } | null;
  const shouldAnimate =
    isNative && (always || navState?.nativeSlideIn === true);

  const animationClass =
    variant === "slide" ? "native-settings-slide-in" : "native-panel-slide-in";

  return (
    <div className={cn(shouldAnimate && animationClass, className)}>
      {children}
    </div>
  );
}
